import { NgModule } from '@angular/core';
import { UserTaskListModule } from './user-task-list/user-task-list.module';
import { UserTaskPreviewModule } from './user-task-preview/user-task-preview.module';
import { UserTaskService } from '../services/user-task.service/user-task.service';
import {UserTaskInfoModule} from "./user-task-preview/info/user-task-info.module";

@NgModule({
  imports: [UserTaskListModule, UserTaskPreviewModule, UserTaskInfoModule],
  exports: [UserTaskListModule, UserTaskPreviewModule, UserTaskInfoModule],
  providers: [UserTaskService],
})
export class UserTasksModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-tasks.module.ts